import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReportReservationResponseV4Schema } from "../response/ReportReservationResponseV4";

const API_VERSION = 'v4';

interface FilterPropsV4 {
    property_id: string;
    base_on: "created_reservation" | "checkin_date" | "checkout_date";
    room_type_id?: string;
}

interface ReportReservationV4Props {
    filter: FilterPropsV4;
    type: string | null;
}

const useReportReservationV4 = (params: ReportReservationV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'report-reservation-v4',
            params.type,
            JSON.stringify(params.filter)
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/property-report-reservation-sales`, {
                    params: { filter: params.filter }
                });

                const validationResult = ReportReservationResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid V4 Reservation report data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch V4 Reservation report`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && params.type === "report_reservation",
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

export default useReportReservationV4;